import type { SearchFieldSize } from 'ui/search-field/search-field.types';

export const SEARCH_DEBOUNCE_MS = 800;

export const SEARCH_ICON_PX = {
  large: 20,
  medium: 16,
} as const satisfies Record<SearchFieldSize, number>;

export const SEARCH_VALUE_GAP_PX = 4;

export const SEARCH_CLEAR_TARGET_PX = 24;
